module.exports = __webpack_public_path__ + "img/Alle Ansichten2.81a1092c.jpg";